"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_FORMAT = exports.DISPLAY_WEEKDAY_DATE_FORMAT = exports.DISPLAY_DATE_FORMAT = exports.DATE_FORMAT = exports.LOST_GPS_UPDATE_INTERVAL = exports.LUNCH_TIME = exports.VALID_TIME_RANGE = exports.MAP_DATA_NOT_READY = exports.NO_DATA_MESSAGE = exports.DEFAULT_TIMEZONE = exports.DEFAULT_LANGUAGE = exports.GOOGLE_API = exports.API = exports.constants = void 0;
exports.constants = {
    logo: 'assets/images/logo.svg',
};
var apiUrl;
switch (process.env.TARGET_ENV) {
    case 'development':
        apiUrl = 'http://localhost:8080';
        break;
    case 'staging':
        apiUrl = 'https://urenportaal-acc.dakota.nl';
        break;
    case 'test':
        apiUrl = 'https://urenportaal-tst.dakota.nl';
        break;
    default:
        apiUrl = 'https://urenportaal.dakota.nl';
}
exports.API = {
    USERS_URI: "".concat(apiUrl, "/api/users"),
    LOGIN_URI: "".concat(apiUrl, "/api/authenticate"),
    FOOTPRINT_URI: "".concat(apiUrl, "/api/footprints/overview/latest"),
    COMPANIES_URI: "".concat(apiUrl, "/api/companies"),
    ADDRESSES_URI: "".concat(apiUrl, "/api/addresses"),
    WEEK_HOURS_URI: "".concat(apiUrl, "/api/worklogs/overview"),
    WORKLOG_LIST_URI: "".concat(apiUrl, "/api/worklogs/list"),
    GPS_STEPS_URI: "".concat(apiUrl, "/api/footprints/calculated"),
    SEARCH_WORK_LOCATIONS: "".concat(apiUrl, "/api/worklocations"),
    SAVE_WORKLOGS: "".concat(apiUrl, "/api/worklogs"),
    APPROVE_HOURS: "".concat(apiUrl, "/api/worklogweeks/"),
    REPORT_HOURS_URI: "".concat(apiUrl, "/api/report/hours/"),
    REPORT_TIMELINES_URI: "".concat(apiUrl, "/api/report/timelines/"),
    CLOSE_MESSAGE_URI: "".concat(apiUrl, "/api/report/closing-message/"),
    WORK_DAY_URI: "".concat(apiUrl, "/api/workdays"),
    GPS_PROPOSAL_URI: "".concat(apiUrl, "/api/gps-proposal"),
    WORKLOG_URI: "".concat(apiUrl, "/api/worklogs"),
    IMPORTS_URI: "".concat(apiUrl, "/api/addresses/imports"),
    IMPORT_STATISTICS_URI: "".concat(apiUrl, "/api/addresses/imports-statistics"),
    HOUR_TYPES_URI: "".concat(apiUrl, "/api/hour-types"),
};
exports.GOOGLE_API = 'AIzaSyDENwXeW_HJNqhFfr9k47oSzqxO2WtLj24';
exports.DEFAULT_LANGUAGE = 'nl';
exports.DEFAULT_TIMEZONE = 'Europe/Amsterdam';
exports.NO_DATA_MESSAGE = 'Geen resultaten';
// tslint:disable-next-line
exports.MAP_DATA_NOT_READY = 'De GPS informatie wordt \'s nachts berekend voor de huidige dag, daarom kan hier nog geen informatie worden getoond. ';
/* RELATED TO WORKLOG VALIDATIONS */
exports.VALID_TIME_RANGE = 0.116; //  7 Minutes
exports.LUNCH_TIME = 1;
exports.LOST_GPS_UPDATE_INTERVAL = 300; // in seconds, 5 mins
exports.DATE_FORMAT = 'YYYY-MM-DD';
exports.DISPLAY_DATE_FORMAT = 'DD-MM-YYYY';
exports.DISPLAY_WEEKDAY_DATE_FORMAT = 'dddd DD-MM-YYYY';
exports.TIME_FORMAT = 'h:mm';
